import { getError } from "@/utils/helpers";
import CartService from "@/services/CartService";

export const namespaced = true;

function setCarts(commit, response) {
  commit("SET_CART", response.data);
  commit("SET_LOADING", false);
}

export const state = {
  cart: [],
  loading: false,
  error: null
};

export const mutations = {
  SET_CART(state, cart) {
    state.cart = cart;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export const actions = {
  getCart({ commit }) {
    commit("SET_LOADING", true);
    CartService.getCart()
      .then(response => {
        setCarts(commit, response);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      });
  },
  emptyCart({ commit }) {
    commit("SET_LOADING", true);
    CartService.clearCart()
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      });
  }
};

export const getters = {
  cart: state => {
    return state.cart;
  },
  loading: state => {
    return state.loading;
  },
  error: state => {
    return state.error;
  }
};
